var exports = {
  "k": "xe564cbfb--4c8104--container",
};

module.exports = exports;
